'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var notify = require('notify');
var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');
var sidePanel = require('./side-panel');
var dataMgr = require('./data-mgr');

var displayEmailValidationMsg = function() {

	// var $email = $('input[name="email"]');
	var $email = $('.contact-login-form__instructions');

	console.log('**displayEmailValidationMsg!');

	notify.show({
		target: $email,
		position: 'top-left',
		closeOnClick: true,
		container: '.contact-login-form',
		msg: window.pbizServer.content.pleaseEnterValidEmail
	});

};

var displayNewAccountConfirmationValidationMsg = function() {

	var $confirm = $('input[name="confirm"]');

	notify.show({
		target: $confirm,
		position: 'bottom-left',
		closeOnClick: true,
		container: '.create-account-form',
		msg: window.pbizServer.content.confirmYourEmail
	});

};

var displayNewAccountPolicyValidationMsg = function() {

	var $policy = $('input[name="policy"]');

	notify.show({
		target: $policy,
		position: 'top-left',
		closeOnClick: true,
		container: '.create-account-form',
		msg: window.pbizServer.content.thisFieldIsRequired
	});

};

var attemptLogin = function() {

	var $confirm = $('input[name="confirm"]');
	var $policy = $('input[name="policy"]');
	var $marketing = $('input[name="marketing"]');
	var $createNewAccount = $('input[name="createNewAccount"]');
	var email = $('input[name="email"]').val();
	var loginDirective = $('input[name="loginDirective"]').val();
	var photoId = $('input[name="photoId"]').val();
	var postData = {};

	postData['email'] = email;
	postData['loginDirective'] = loginDirective;
	postData['photoId'] = photoId;

	if ($createNewAccount.length) {

		postData.createNewAccount = true;

	}

	if ($confirm.length && $confirm[0].checked) {

		postData.confirm = true;

	}

	// This checkbox may or may not be present based on the policy settings, and since it's a required field, if it is present, we have to explicitly send a true or false value to properly handle the server side validation
	if ($policy.length) {

		if ($policy[0].checked) {

			postData.policy = true;

		} else {

			postData.policy = false;

		}

	}

	if ($marketing.length) {

		if ($marketing[0].checked) {

			postData.marketing = true;

		} else {

			postData.marketing = false;

		}

	}

	$.ajax({
		type: 'POST',
		dataType: 'JSON',
		url: dataMgr.getEventUrl() + '?page=contact_login_action',
		data: postData
	}).done(function(response) {

		triggerCustomEvent(response.status.detail, {
			data: {
				response: response
			}
		});

	});

};

var renderLoginForm = function(loginData) {

	var $email = $('input[name="email"]');

	console.log('render the login form!!');
	console.log(loginData);

	loginData = typeof loginData !== 'undefined' ? loginData : {};

	loginData.email = $email.val();

	$.ajax({
		type: 'POST',
		dataType: 'JSON',
		url: dataMgr.getEventUrl() + '?page=load_contact_login_form',
		data: loginData
	}).done(function(response){

		sidePanel.open(response.markup, {type: 'contact-login'});

	});

};

var addEventHandlers = function() {

	appDom.document.on('contact_access_denied', function(e, data) {

		renderLoginForm(data.response);

	});

	appDom.document.on('keypress', '[name="email"]', function(e) {

		if (e.which === 13) {

			attemptLogin();

			e.preventDefault();

		}

	});

	appDom.document.on('click', '.contact-login-form__submit-btn,.create-account-form__create-account-btn', function(e) {

		console.log('login submit button was clicked');

		attemptLogin();

		e.preventDefault();

	});

	appDom.document.on('click', '.create-account-form__change-email-btn', function(e) {

		var loginData = {};

		console.log('change email clicked');

		loginData.loginDirective = $('input[name="loginDirective"]').val();

		renderLoginForm(loginData);

		e.preventDefault();

	});

	appDom.document.on('contact_login_account_creation_attempted', function(e, data) {

		sidePanel.open(data.response.markup, {type: 'contact-login'});

	});

	appDom.document.on('contact_login_account_creation_email_not_confirmed', function() {

		console.log('account NOT confirmed');

		displayNewAccountConfirmationValidationMsg();

	});

	appDom.document.on('contact_login_account_creation_policy_not_accepted', function() {

		displayNewAccountPolicyValidationMsg();

	});

	appDom.document.on('contact_login_invalid_email', function() {

		displayEmailValidationMsg();

	});

	appDom.document.on('side_panel_opened side_panel_closed', function() {

		notify.hide();

	});

	appDom.document.on('contact_login_success contact_login_account_creation_success', function(e, data) {

		var dontCloseList = 'cart_view';

		if (!data.response.loginDirective) {

			console.error('Missing login directive! Check the flow of events that led to here to make sure loginDirective is properly set and propagated.');

		}

		if (dontCloseList.indexOf(data.response.loginDirective) === -1) {

			sidePanel.close();

		}

		triggerCustomEvent(data.response.loginDirective, {
			data: {
				response: data.response
			}
		});

	});

};

var init = function() {

	addEventHandlers();

};

module.exports = {
	init: init
};
